export default address =>
  `https://maps.google.com/maps?q=${encodeURIComponent(address)}`;
